import { create } from 'zustand';
import { msgInfo } from './components/constants';

const initialState = {
  session_id: '',
  messages: [],
  client_id: '',
  conversation_id: '',
  conversation: [],
  clientError: false,
};

export const useSalesAssistStore = create((set, get) => ({
  ...initialState,
  setId: (id) => set(() => ({ session_id: id })),
  updateMessages: (newMessage) => {
    const temp = [newMessage, ...get().messages];
    return set({ messages: temp });
  },
  addUserMessage: (message) =>
    set((state) => ({ messages: [{ type: msgInfo.sender, text: message }, ...state.messages] })),
  startAIMessage: () =>
    set((state) => ({ messages: [{ type: msgInfo.recipient, text: '' }, ...state.messages] })),
  addToLastAIMessage: (textLine) =>
    set((state) => {
      const updatedMessages = [...state.messages];
      updatedMessages[0].text += textLine;
      return { messages: updatedMessages };
    }),
  setClientID: (id) => set(() => ({ client_id: id })),
  setConversationID: (value) => set(() => ({ conversation_id: value })),
  addNewUserMessage: (text) =>
    set((state) => ({
      conversation: [
        { type: msgInfo.sender, message: text, content: text, role: 'user' },
        ...state.conversation,
      ],
    })),
  addAIResponseChunk: (chunk) =>
    set((state) => {
      const clean = normalizeChunk(chunk);
      const copyConversation = [...state.conversation];
      const last = copyConversation[0];

      if (last && last.type === msgInfo.recipient) {
        last.content += clean;
        last.text += clean;
        copyConversation[0] = { ...last };
      } else {
        copyConversation.unshift({
          type: msgInfo.recipient,
          role: 'assistant',
          content: clean,
          text: clean,
        });
      }

      return { conversation: copyConversation };
    }),
  addAIRegenerationResponseChunk: (chunk, messageId) =>
    set((state) => {
      const clean = normalizeChunk(chunk);
      const copyConversation = [...state.conversation];
      const currentMsgIndex = copyConversation.findIndex((c) => c.message_id === messageId);

      if(currentMsgIndex < 0) return { conversation: copyConversation };

      copyConversation[currentMsgIndex].content += clean;
      copyConversation[currentMsgIndex].text += clean;

      return { conversation: copyConversation };
    }),
  setConversation: (conversation = []) => set(() => ({ conversation })),
  setClientError: () => set(() => ({ clientError: true })),
  reset: () => {
    set(initialState);
  },
}));

const normalizeChunk = (chunk) => {
  let clean = chunk;

  clean = clean.replace(/\\"/g, '"');
  clean = clean.replace(/\\n/g, '\n');

  if (clean.startsWith('"') && clean.endsWith('"')) {
    clean = clean.slice(1, -1);
  }

  clean = clean.replace(/\*\*\s*\n/g, '**\n');
  clean = clean.replace(/\n{3,}/g, '\n\n');

  clean = clean.replace(/\s+=\s+/g, '=');

  return clean;
};
